import Telephone from '../../../assets/telephone.svg';

const TelephoneIcon = (props: React.SVGProps<SVGSVGElement> & { rotation?: number }): JSX.Element => {
  const { rotation = 0, ...restProps } = props;

  return <Telephone fill={'#0090E3'} transform={`rotate(${rotation})`} {...restProps} />;
};

export default TelephoneIcon;
